<div class="score">
  <p i18n class="score__text">
    Best : <strong class="score__text_bold">{{ bestScore$ | async }}</strong>
  </p>

  <p i18n class="score__text">
    Score : <strong class="score__text_bold">{{ currentScore$ | async }}</strong>
  </p>

  <button i18n class="score__menu" (click)="showMenu()">Menu</button>
</div>
